/**
 * ToDo API
 * An ASP.NET Core Web API for managing ToDo items
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { InvoiceLineItemRequest } from './invoiceLineItemRequest';


export interface InvoiceCreateRequest { 
    invoiceId?: string;
    invoiceNumber?: string;
    invoiceDueDate?: string;
    lineItemRequests?: Array<InvoiceLineItemRequest>;
    userId?: string;
    isInAppInvoice?: boolean;
    isStripeInvoice?: boolean;
    provider?: string;
    jobEvents?: { [key: string]: Array<string>; };
    memo?: string;
}

